import { AppsModule } from "src/app/pages/apps/apps.module";
import { CommonModule } from '@angular/common';
import { CommunicationsEmbeddedComponent } from "./communications/communications.component";
import { CountryGroupCountriesEmbeddedComponent } from "./country-group-countries/country-group-countries.component";
import { CountryGroupsEmbeddedComponent } from "./country-groups/country-groups.component";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { DownloadableFilesEmbeddedComponent } from "./downloadable-files/downloadable-files.component";
import { DropdownsModule } from "../core/dropdowns/dropdowns.module";
import { FormsModalConfirmationModule } from "src/app/forms-modal-confirmation/forms-modal-confirmation.module"
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GridViewModule } from "src/app/core/grid-view/grid-view.module";
import { InviewUsersEmbeddedComponent } from "./inview-users/inview-users.component";
import { LicencesCompanyVisibleEmbeddedComponent } from "./licences-company-visible/licences-company-visible.component";
import { LicencesCompanyVisibleSearchEmbeddedComponent } from "./licences-company-visible-search/licences-company-visible-search.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PageComponentsModule } from "src/app/core/page-components/page-components.module";
import { SharedModule } from "src/app/shared/shared.module";
import { SimAlertsLogEmbeddedComponent } from "./sim-alerts-log/sim-alerts-log.component";
import { SimDataSessionsEmbeddedComponent } from "./sim-data-sessions/sim-data-sessions.component";
import { SimEsimLogEmbeddedComponent } from "./sim-esim-log/sim-esim-log.component";
import { SimNetworkEventEmbeddedComponent } from "./sim-network-event/sim-network-event.component";
import { SimNetworkEventsEmbeddedComponent } from "./sim-network-events/sim-network-events.component";
import { SimProductChangeLogEmbeddedComponent } from "./sim-product-change-log/sim-product-change-log.component";
import { SimProvisionBulkEmbeddedComponent } from "./sim-provision-bulk/sim-provision-bulk.component";
import { StatTileModule } from "src/app/shared/stat-tile/stat-tile.module";
import { ToastsContainer } from "src/app/shared/toast/toasts-container.component";
import { UserGroupsEmbeddedComponent } from "./user-groups/user-groups.component";
import { UsersAllEmbeddedComponent } from "./users-all/users-all.component";
import { UsersPortalEmbeddedComponent } from "./users-portal/users-portal.component";
import { Widget_NoFormsModalModule_Module } from "../shared/widget-no-formsmodalmodule/widget-no-formsmodalmodule.module";

@NgModule({
  declarations: [
    CommunicationsEmbeddedComponent,
    CountryGroupCountriesEmbeddedComponent,
    CountryGroupsEmbeddedComponent,
    DownloadableFilesEmbeddedComponent,
    InviewUsersEmbeddedComponent,
    LicencesCompanyVisibleEmbeddedComponent,
    LicencesCompanyVisibleSearchEmbeddedComponent,
    SimAlertsLogEmbeddedComponent,
    SimDataSessionsEmbeddedComponent,
    SimEsimLogEmbeddedComponent,
    SimNetworkEventEmbeddedComponent,
    SimNetworkEventsEmbeddedComponent,
    SimProductChangeLogEmbeddedComponent,
    SimProvisionBulkEmbeddedComponent,
    UserGroupsEmbeddedComponent,
    UsersAllEmbeddedComponent,
    UsersPortalEmbeddedComponent
  ],
  imports: [
    AppsModule,
    CommonModule,
    DropdownsModule,
    FormsModalConfirmationModule,
    FormsModule,
    GridViewModule,
    NgbModule,
    PageComponentsModule,
    ReactiveFormsModule,
    SharedModule,
    StatTileModule,
    ToastsContainer,
    Widget_NoFormsModalModule_Module
  ],
  exports: [
    CommunicationsEmbeddedComponent,
    CountryGroupCountriesEmbeddedComponent,
    CountryGroupsEmbeddedComponent,
    DownloadableFilesEmbeddedComponent,
    InviewUsersEmbeddedComponent,
    LicencesCompanyVisibleEmbeddedComponent,
    LicencesCompanyVisibleSearchEmbeddedComponent,
    SimAlertsLogEmbeddedComponent,
    SimDataSessionsEmbeddedComponent,
    SimEsimLogEmbeddedComponent,
    SimNetworkEventEmbeddedComponent,
    SimNetworkEventsEmbeddedComponent,
    SimProductChangeLogEmbeddedComponent,
    SimProvisionBulkEmbeddedComponent,
    UserGroupsEmbeddedComponent,
    UsersAllEmbeddedComponent,
    UsersPortalEmbeddedComponent
  ],
  providers: [

  ],
  schemas: [
     CUSTOM_ELEMENTS_SCHEMA
  ],
})

export class PagesEmbeddedModule {
  constructor() { }
}
